import { Link } from "react-router-dom";
import Blink from "../../../components/blink";


export default function Footer({
  globalSearchPopup,
  setGlobalSearchPopup
}: any) {

  return (
    <>
      <footer className="footer">


        <div className="footer-content">
          <div className="container">
            <div className="row py-3">

              <div className="col-xl-3 col-md-3 col-6">
                <div className="footer-widget mb-4">
                  <div className="footer-widget-heading">
                    <h3 className="ropa-sans-regular">About Us</h3>
                  </div>
                  <ul>
                    <li><Link to="/about">About TCTDMC </Link></li>
                    <li><Link to="/newsroom">Newsroom</Link></li>
                    <li><a role="button">Corporate Information</a></li>
                    <li><Link to="/careers">Careers </Link> <Blink><span className="text-danger">We’re Hiring!</span></Blink></li>

                  </ul>
                </div>
              </div>
              <div className="col-xl-3 col-md-3 col-6">
                <div className="footer-widget mb-4">
                  <div className="footer-widget-heading">
                    <h3 className="ropa-sans-regular">Book & Manage</h3>
                  </div>
                  <ul>
                    <li><a role="button" onClick={() => setGlobalSearchPopup(true)}>Search</a></li>
                    <li><Link to="/bookManage">Manage Booking</Link></li>
                    <li><a role="button">Tour Schedule</a></li>
                    <li><a role="button">How to Book</a></li>
                  </ul>
                </div>
              </div>
              <div className="col-xl-3 col-md-3 col-6">
                <div className="footer-widget mb-4">
                  <div className="footer-widget-heading">
                    <h3 className="ropa-sans-regular">Discover Us</h3>
                  </div>
                  <ul>
                    <li><Link to="/whatWeDo">What we Do</Link></li>
                    <li><Link to="/destination">Destinations </Link></li>
                    <li><a role="button">Meet The Team</a></li>
                    <li><a role="button">Come and See Us </a></li>
                  </ul>
                </div>
              </div>
              <div className="col-xl-3 col-md-3 col-6">
                <div className="footer-widget mb-4">
                  <div className="footer-widget-heading">
                    <h3 className="ropa-sans-regular">Travel Assistance</h3>
                  </div>
                  <ul>
                    <li><Link to="/airport">Airport Information</Link></li>
                    <li><Link to="/firstTravellers">First-time Travellers, Children & Pets</Link></li>
                    <li><Link to="/visaDocuments">Visa, Documents and Travels Tips</Link></li>
                    <li><Link to="/">Health and Medical Assistance</Link></li>
                  </ul>
                </div>
              </div>
              <div className="col-xl-3 col-md-3 col-6">
                <div className="footer-widget mb-4">
                  <div className="footer-widget-heading">
                    <h3 className="ropa-sans-regular">Support</h3>
                  </div>
                  <ul>
                    <li><Link to="/contact">Contact Us</Link></li>
                    <li><a role="button">Leave Your Feedback</a></li>
                    <li><a role="button">FAQ</a></li>
                    <li><a role="button">Grievance Resolution</a></li>
                  </ul>
                </div>
              </div>
              <div className="col-xl-3 col-md-3 col-6">
                <div className="footer-widget mb-4">
                  <div className="footer-widget-heading">
                    <h3 className="ropa-sans-regular">Resources</h3>
                  </div>
                  <ul>
                    <li><Link to="/blogs">Blogs</Link></li>
                    <li><a role="button">Video Blogs</a></li>
                    <li><Link to="/articles">Articles</Link></li>
                    <li><a role="button">Podcasts</a></li>
                  </ul>
                </div>
              </div>
              <div className="col-xl-3 col-md-3 col-6">
                <div className="footer-widget mb-4">
                  <div className="footer-widget-heading">
                    <h3 className="ropa-sans-regular">Stay informed</h3>
                  </div>
                  <ul>
                    <li><Link to="/">Agent Review</Link></li>
                    <li><a role="button">The Important Bits</a></li>
                    <li><a role="button">Sustainability</a></li>
                    <li><a role="button">Passenger Rights</a></li>
                  </ul>
                </div>
              </div>
              <div className="col-xl-3 col-md-3 col-6">
                <div className="footer-widget mb-4">
                  <div className="footer-widget-heading">
                    <h3 className="ropa-sans-regular">TCTDMC App</h3>
                  </div>
                  <div className="footer-widget">
                    <p className="mb-0">Download the app to book and manage your tour on the go. <a role="button">Learn more Details</a></p>
                    <div className="app-logo d-flex column-gap-1">
                      <img loading="lazy" height={54} src="../../../assets/images/appstore-logo.svg" alt="" />
                      <img loading="lazy" height={54} src="../../../assets/images/google-play-logo.svg" alt="" />
                    </div>
                  </div>

                </div>
              </div>
            </div>
            <div className="footer-social border-bottom border-top py-3">
              <div className="row">
                <div className="col-xl-6 col-md-6 col-md-6">
                  <div className="footer-widget">
                    <ul className="grid">
                      <li><Link to="/terms-condition">Terms & Conditions</Link></li>
                      <li><Link to="/privacy-policy">Privacy Policy</Link></li>
                      <li><Link to="/refund-policy">Refund Policy</Link></li>
                      <li><Link to="/cookies">Cookie Policy</Link></li>
                      <li><Link to="/disruption">Disruption Statement</Link></li>
                      <li><Link to="/accessibility">Accessibility Plan & Feedback Process</Link></li>
                      <li><Link to="/agents-rights">Travels Agents Rights</Link></li>
                      <li><Link to="/registration">Become a Partner</Link></li>
                    </ul>
                  </div>
                </div>
                <div className="col-xl-3 col-md-3 col-4">
                  <div className="footer-widget">
                    <img loading="lazy" width={70} src="../../../assets/images/logo.png" alt="" />
                    <div className="footer-widget-heading pt-2">
                      {/* <p className="mb-0"><strong>Don’t just see Thailand – feel Thailand</strong></p> */}
                    </div>
                  </div>
                </div>
                <div className="col-xl-3 col-md-3 col-8">
                  <div className="footer-widget-heading">
                    <h3 className="ropa-sans-regular">Follow Us</h3>
                  </div>
                  <div className="footer-social-icon">
                    <a href="https://www.facebook.com/tctdmc" target="_blank"><i className='bx bxl-facebook-circle'></i></a>
                    <a href="https://www.linkedin.com/in/tctdmc" target="_blank"><i className='bx bxl-linkedin' ></i></a>
                    <a href="https://x.com/tctdmc" target="_blank"><i className='bx bxl-twitter' ></i></a>
                    <a href="https://www.instagram.com/tctdmc" target="_blank"><i className='bx bxl-instagram-alt' ></i></a>
                    <a href="https://www.youtube.com/@tctdmc" target="_blank"><i className='bx bxl-youtube' ></i></a>
                  </div>
                </div>
              </div>

            </div>
          </div>

          {/* <hr className="mb-4" /> */}

          <div className="bg-dark d-flex">
            <div className="container">
              <div className="authorized-area">
                <div className="authorized-text">
                  <strong>Payments on website are secure </strong>
                  <img loading="lazy" width={88} src="../../../assets/images/amazing-thailand-logo.png" alt="" />
                  <img loading="lazy" width={77} src="../../../assets/images/DBD-logo.png" alt="" />
                  <img loading="lazy" width={55} src="../../../assets/images/turism-authorized-logo.png" alt="" />
                </div>
              </div>

              <div className="disclaimer text-center border-bottom">
                <p className="text-center"><strong>Caution: Beware of Fake Promotions or Offers </strong>
                  *Please do not believe or engage with any promotional emails, SMS or Web-link which ask you to click on a link and fill in your details. All <strong>TCTDMC</strong> authorized email communications are delivered from domain <strong>@tctdmc.com</strong> or <strong>@tctdmc.in</strong> or <strong>SMS</strong> from <strong>TCTDMC</strong> *TCTDMC bears no liability or responsibility whatsoever for any communication which is fraudulent or misleading in nature and not received from a registered domain.
                </p>
              </div>
              <div className="copyright-area">
                <div className="container">
                  <div className="row">
                    <div className="col-xl-12 col-lg-6">
                      <div className="copyright-text text-center">
                        <p> &copy; 2025 Trip Click Tourism Co.,Ltd.  
                        All rights reserved. Use of this website indicates your compliance with our <Link to="privacy-policy">Privacy Policy</Link>, Conditions of Carriage, <Link to="terms-condition">Terms and Conditions</Link>.</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

      </footer>

    </>
  )
}
